// Modelo para guias proessat
export default class GuiaProessat {
    id=""
    area=""
    description=""
    company={}
    guiaProessatData=[]
    date=""
}



// WEBPACK FOOTER //
// ./src/model/GuiaProessat.js